module.exports = __webpack_public_path__ + "img/allocationquery.78279c30.png";